var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "completeness-check-modal-details" },
    [
      _c(
        "table-attachment",
        {
          staticClass: "completeness-check-modal-details__attachment",
          attrs: { "attachment-position": "top" },
        },
        [
          _c("table-search", {
            attrs: {
              "placeholder-text": _vm.$t(
                "completenessCheckDetailModal.filterById"
              ),
            },
            on: { "filter-by-keyword": _vm.filterByKeywordChanged },
          }),
        ],
        1
      ),
      _c(
        "pui-loader",
        { attrs: { promise: _vm.completenessCheckDetailsPromise } },
        [
          _c(
            "table",
            { staticClass: "completeness-check-modal-details__table" },
            [
              _c("thead", [
                _c(
                  "tr",
                  _vm._l(_vm.columns, function (column, index) {
                    return _c(
                      "th",
                      {
                        key: index,
                        class: [
                          index === 0
                            ? "completeness-check-modal-details__table__value-identification-cell--heading"
                            : "completeness-check-modal-details__table__hour-cell--heading",
                        ],
                      },
                      [_vm._v(" " + _vm._s(_vm.headings[column]) + " ")]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.tableData, function (data, dataIndex) {
                  return _c(
                    "tr",
                    { key: dataIndex },
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "completeness-check-modal-details__table__value-identification-cell--data",
                        },
                        [_vm._v(" " + _vm._s(data[_vm.columns[0]]) + " ")]
                      ),
                      _vm._l(_vm.hoursInDayStrings, function (hour, hourIndex) {
                        return _c(
                          "td",
                          {
                            key: hourIndex,
                            staticClass:
                              "completeness-check-modal-details__table__hour-cell--data",
                          },
                          [
                            _c("completeness-check-modal-details-table-cell", {
                              attrs: {
                                positioning:
                                  hourIndex < _vm.hoursInDayStrings.length / 2
                                    ? "right"
                                    : "left",
                                "hourly-data": data[hour],
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
      _c(
        "table-attachment",
        {
          staticClass: "completeness-check-modal-details__attachment",
          attrs: { "attachment-position": "bottom" },
        },
        [
          _c("table-pagination", {
            attrs: { "total-count": _vm.completenessCheckFilteredItemsCount },
            on: {
              "change:page-number": _vm.pageNumberChanged,
              "change:page-size": _vm.pageSizeChanged,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }